export const TALENT_NETWORK_MEMBERSHIP_STATUSES = [
  "pending_verification",
  "active",
  "left",
] as const;

export const TALENT_NETWORK_SOURCES = [
  "talent_network",
  "creator_invite",
  "public_profile",
  "legacy_audience",
] as const;

export const TALENT_NETWORK_VERIFICATION_LEVELS = [
  "dual_otp",
  "email_only",
  "phone_only",
  "legacy_unverified",
] as const;

export const TALENT_NETWORK_MONETIZATION_REASONS = {
  OTHER_CREATOR: "other_creator",
  INCOMPLETE_PROFILE: "incomplete_profile",
  PHONE_UNVERIFIED: "phone_unverified",
  ATTRIBUTION_PENDING: "attribution_pending",
  MEMBERSHIP_INACTIVE: "membership_inactive",
} as const;
